import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import Router from 'next/router';
import { useContext, useEffect } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { usePagination } from '~/context/srp/InventoryContext';
import SEOContext from '~/context/srp/SEOContext';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';

export default function useSetPageNumber() {
  const { pageNumber, setPageNumber } = useContext(AppliedFiltersContext);
  const { setChanged } = useContext(SEOContext);
  const { currentPage: pageNumberFromInventory } = usePagination();

  const { request } = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT, {
    includePageNumber: false
  });

  // Update URL
  useEffect(() => {
    const url = new URL(window.location.href);

    if (pageNumber <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(pageNumber));
    }

    if (window.location.href !== url.toString()) {
      void Router.push(url, undefined, { shallow: true });
    }
  }, [pageNumber]);

  // Reset when something changes, e.g. filters, sort, or trade-in
  useSubsequentEffect(() => {
    setChanged();
    setPageNumber(1);
  }, [request, setChanged, setPageNumber]);

  // Synchronize with Search API response
  useSubsequentEffect(() => {
    if (pageNumberFromInventory) {
      setPageNumber(pageNumberFromInventory);
    }
  }, [pageNumberFromInventory, setPageNumber]);
}
